// extracted by mini-css-extract-plugin
export default {"quote":"Quote_quote__q5iYI","quoteBg":"Quote_quoteBg__S4zs+","title":"Quote_title__iFsGC","quoteImg":"Quote_quoteImg__Tjeys","desc":"Quote_desc__9dIiL","sign":"Quote_sign__8F9Ty"};